import React, { useState } from "react";
import { Button, Checkbox, DatePicker, Form, Image, Input, Layout, message, notification, Radio, Select, Typography } from "antd";
import HeaderComponent from "../component/header";
import { API_URL } from "../constant";
import { CheckOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

const { Option } = Select;
const { Title } = Typography;
const { Link } = Typography;
const { Header } = Layout;

const NewFormPage: React.FC = () => {
  const [form] = Form.useForm();


  const onSubmit = () => {
    console.log("Form submitted");  
  };

  const onFinishFailed = (errorInfo: any) => {
    alert("Please check the form fields and try again.");
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${API_URL}online-quotation-inquiry/images/renewalshort.pdf`;
    link.download = "filename.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <HeaderComponent />
      <div className='mt-10 max-w-screen-xl mx-auto p-20'>

        <div className='flex flex-col mb-10'>
          <Title level={2} className="flex justify-center">CHIROPRACTIC PROFESSIONAL LIABILITY INSURANCE APPLICATION</Title>
        </div>

        <Form
          form={form}
          layout="horizontal"
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 mb-5'>
                    <span>
                        Instructions:<br></br>
                        &nbsp;&nbsp;&nbsp;• The application and any additional sheets must be completed, signed and dated by the applicant.<br></br>
                        &nbsp;&nbsp;&nbsp;• Answer all questions completely. If the question does not pertain to your practice, answer “N/A”.<br></br>
                        &nbsp;&nbsp;&nbsp;• If additional space is needed, please use a separate sheet of paper.<br></br>
                        &nbsp;&nbsp;&nbsp;• Type or print clearly in ink. DO NOT USE PENCIL.<br></br> 
                    </span>
                </div>
                
                <div className='col-span-2 sm:col-span-6'>
                    <Title level={5}>I. PERSONAL INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Name" name="first_name" rules={[{ required: true }]}>
                        <Input placeholder="First Name" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item label="" name="middle_name" rules={[{ required: true }]}>
                        <Input placeholder="Middle Name" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item label="" name="last_name" rules={[{ required: true }]}>
                        <Input placeholder="Last Name" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Date of Birth:" name="date_of_birth" rules={[{ required: true }]}>
                        <DatePicker placeholder="Please enter Date" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Practice address" name="practice_street" rules={[{ required: true }]}>
                        <Input placeholder="Street" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item label="" name="practice_city" rules={[{ required: true }]}>
                        <Input placeholder="City" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item label="" name="practice_state" rules={[{ required: true }]}>
                        <Input placeholder="State" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item label="" name="practice_zip" rules={[{ required: true }]}>
                        <Input placeholder="Zip" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item label="Country" name="country" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Country" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="Additional Practice Locations, if any. If “none” please indicate:" name="additional_practice_locations" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Additional Practice Locations" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Mailing Address: " name="mailing_street" rules={[{ required: true }]}>
                        <Input placeholder="Street" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="" name="mailing_city" rules={[{ required: true }]}>
                        <Input placeholder="City" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item label="" name="mailing_state" rules={[{ required: true }]}>
                        <Input placeholder="State" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item label="" name="mailing_zip" rules={[{ required: true }, { pattern: /^\d{5}(-\d{4})?$/, message: 'Use XXXXX or XXXXX-XXXX format please' }]}>
                        <Input placeholder="ZIP code" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Home Address: " name="home_street" rules={[{ required: true }]}>
                        <Input placeholder="Street" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="" name="home_city" rules={[{ required: true }]}>
                        <Input placeholder="City" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item label="" name="home_state" rules={[{ required: true }]}>
                        <Input placeholder="State" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
                    <Form.Item label="" name="home_zip" rules={[{ required: true }, { pattern: /^\d{5}(-\d{4})?$/, message: 'Use XXXXX or XXXXX-XXXX format please' }]}>
                        <Input placeholder="ZIP code" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="Office Phone" name="office_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                        <Input placeholder="Please enter your Office Phone" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="Home or Cell Phone:" name="cell_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                        <Input placeholder="Please enter your Home or Cell Phone" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item label="Fax" name="fax" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                        <Input placeholder="Please enter your Fax" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Email:" name="email" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Email" />
                    </Form.Item>
                </div>
                 <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Secondary Email:" name="secondary_email" rules={[{ required: false }]}>
                        <Input placeholder="Please enter your Secondary Email" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="WebSite :" name="website" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your WebSite" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="List Chiropractic Association Memberships :" name="list_memberships" rules={[{ required: true }]}>
                        <Input placeholder="Please enter your Chiropractic Association Memberships" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6'>
                    <Title level={5}>LICENSE, EDUCATION AND QUALIFICATION INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4'>
                    <Form.Item label="Chiropractic College Attended" name="chiropractic_college" rules={[{ required: true }]}>
                        <Input placeholder="Please enter Chiropractic College Attended" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Date of graduation:" name="date_of_graduation" rules={[{ required: true }]}>
                        <DatePicker placeholder="" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="Additional Specialty Degrees or Certificates, if any (Please do not abbreviate):" name="additional_specialty_degrees" rules={[{ required: true }]}>
                        <Input placeholder="Please enter Additional Specialty Degrees or Certificates" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Original License Date:" name="original_license_date" rules={[{ required: true }]}>
                        <DatePicker placeholder="" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4'>
                    <Form.Item label="Date first started practicing as licensed Chiropractor:" name="date_first_started_practicing" rules={[{ required: true }]}>
                        <DatePicker placeholder="" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 ml-10'>
                    <Title level={5}>Important: Please attach a copy of your current license</Title>
                </div>
                <div className='col-span-2 sm:col-span-6'>
                    List all states in which you hold or have held a chiropractic license. 
                </div>
            </div>
            
            <div className="flex justify-center">
                <table style={{ border: "solid 1px black", width: "80%" }}>
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "30%" }}>
                            State
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "20%" }}>
                            LICENSE NUMBER
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "25%" }}>
                            PERIOD OF LICENSURE
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="state_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="license_number_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="period_of_licensure_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="state_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="license_number_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="period_of_licensure_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="state_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="license_number_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="period_of_licensure_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                </table>
            </div>
            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2 mt-5'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="List Chiropractic Association Memberships:" name="chiropractic_association_memberships" rules={[{ required: true }]}>
                        <Input placeholder="Please enter Chiropractic Association Memberships" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Title level={5}>II. POLICY INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item label="1. Requested Effective Date of coverage (subject to underwriting approval)" name="date_effective" rules={[{ required: true }]}>
                        <DatePicker placeholder="" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='ml-6 col-span-2 sm:col-span-6 lg:col-span-2'>
                    <p>  Requested Policy Form:</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item name="occurrence_check" valuePropName="checked">
                        <Checkbox>Occurrence</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item name="claims_made_check" valuePropName="checked">
                        <Checkbox>Claims Made</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-6 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <p>{"a)"}&nbsp;&nbsp;&nbsp;{"Do you desire Prior Acts Coverage?"}</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="desire_prior_acts_coverage" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-6 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <p>{"b)"}&nbsp;&nbsp;&nbsp;{"If so, what is the Retroactive/Prior Acts date on your current Claims Made Policy?"}</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="date_prior_acts" valuePropName="checked">
                        <DatePicker placeholder="" style={{ width: "100%" }} />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <span className="font-bold">You must attach a copy of your most recent Declarations Page to receive retroactive coverage(Subject to underwriting approval). </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <span>2. &nbsp;&nbsp;List all Current and Prior Malpractice Carriers and Policy Information for the past (5) years</span>
                </div>
            </div>
            <div className="flex flex-col justify-center">
                <table border={1} cellSpacing="0" cellPadding="8" style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th rowSpan={2}>INSURANCE COMPANY</th>
                            <th colSpan={2}>POLICY PERIOD</th>
                            <th rowSpan={2}>LIMITS OF LIABILITY</th>
                            <th colSpan={2}>POLICY TYPE</th>
                        </tr>
                        <tr>
                            <th>From</th>
                            <th>To</th>
                            <th>Claims-Made</th>
                            <th>Occurrence</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <Form.Item  className="mb-0" name="insurance_company_1" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_period_from_1" rules={[{ required: true }]}>
                                    <DatePicker/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_period_to_1" rules={[{ required: true }]}>
                                    <DatePicker/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="limits_of_liability_1" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_type_claims_made_1" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_type_occurrence_1" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Form.Item  className="mb-0" name="insurance_company_2" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_period_from_2" rules={[{ required: true }]}>
                                    <DatePicker/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_period_to_2" rules={[{ required: true }]}>
                                    <DatePicker/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="limits_of_liability_2" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_type_claims_made_2" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item  className="mb-0" name="policy_type_occurrence_2" rules={[{ required: true }]}>
                                    <Input/>
                                </Form.Item>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2 mt-5'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    <span>If you do not have a current malpractice insurance policy or have not had coverage in the last 5 years, please provide an explanation of why you were uninsured.</span>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-6'>
                    <Form.Item name="reason_uninsured" valuePropName="checked">
                        <TextArea/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <span>3. &nbsp;&nbsp;Limits of Liability requested: </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 ml-10'>
                    <Form.Item name="limits_of_liability_1" valuePropName="checked" className=" mb-0">
                        <Checkbox>$100,000 each Wrongful Act / $300,000 Aggregate</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 ml-10'>
                    <Form.Item name="limits_of_liability_2" valuePropName="checked" className=" mb-0">
                        <Checkbox>$200,000 each Wrongful Act / $600,000 Aggregate</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 ml-10'>
                    <Form.Item name="limits_of_liability_3" valuePropName="checked" className=" mb-0">
                        <Checkbox>$250,000 each Wrongful Act / $750,000 Aggregate</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 ml-10'>
                    <Form.Item name="limits_of_liability_4" valuePropName="checked" className=" mb-0">
                        <Checkbox>$500,000 each Wrongful act / $1,500,000 Aggregate</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 ml-10'>
                    <Form.Item name="limits_of_liability_5" valuePropName="checked" className=" mb-0">
                        <Checkbox>$1,000,000 each Wrongful Act / $3,000,000 Aggregate</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 ml-10'>
                    <Form.Item name="limits_of_liability_6" valuePropName="checked" className=" mb-0">
                        <Checkbox>$2,000,000 each Wrongful Act / $4,000,000 Aggregate</Checkbox>
                    </Form.Item>
                </div>
                <div className='mt-4 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Title level={5}>III. CURRENT PRACTICE INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <span>1. If you work as an <b>employee or independent contractor</b>, please provide
                            the name of the facility where you work and the name and professional
                            licensure and/or designation of owner:</span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="facility_info" rules={[{ required: true }]}>
                        <Input placeholder="Please enter the facility info" />
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    Are any additional insured’s (i.e Landlord, Owner, etc.) needed for your practice?
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    If you are an employee, please proceed to question #3 of III. 
                </div>
                <div className='mt-2 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>2. If you own your practice, please advise of the following:</p>
                </div>
                <div className='col-span-2 ml-4 sm:col-span-3 lg:col-span-3'>
                    <p>A.&nbsp;&nbsp;&nbsp;Business structure under which you practice:</p>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="sole_proprietor" valuePropName="checked">
                        <Checkbox>Sole Proprietor</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-2 lg:col-span-2'>
                    <Form.Item name="incorporated_pc_pa" valuePropName="checked">
                        <Checkbox>Incorporated, P.C. or P.A</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-1 lg:col-span-1'>
                    <div className="flex flex-row">
                        <p className="mt-1 mr-4">B. </p>
                        <Form.Item name="llc_llp" valuePropName="checked">
                            <Checkbox>L.L.C. or L.L.P.</Checkbox>
                        </Form.Item>
                    </div>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="partnership" valuePropName="checked">
                        <Checkbox>Partnership</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item name="other" valuePropName="checked">
                        <Checkbox>Other (Please specify) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-3 lg:col-span-3'>
                    <Form.Item name="other_specify" rules={[{ required: false }]}>
                        <Input/>
                    </Form.Item>
                </div>
            </div>
            <div className="grid grid-cols-[auto_1fr] gap-2">
                <span className="ml-4 mr-3 mt-2">C. </span>
                <div className="">
                    <Form.Item
                    label="Please provide the name of your legal entity (if any):"
                    name="legal_entity_name"
                    rules={[{ required: true }]}
                    >
                        <Input placeholder="Please enter the name of your legal entity" />
                    </Form.Item>
                </div>
            </div>
            <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item
                    label="FEIN or TAX ID number of the legal entity:"
                    name="legal_entity_tax_id"
                    rules={[{ required: true }]}
                    >
                        <Input placeholder="Please enter the FEIN or TAX ID number of your legal entity" />
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>D.&nbsp;&nbsp;&nbsp; Including yourself, name shareholders, owners, officers, partners, etc, their professional designation  and relationship:</p>
                </div>
            </div>
            <div className="flex justify-center">
                <table border={1} cellSpacing="0" cellPadding="8" style={{ border: '1px solid black', borderCollapse: 'collapse', width: "80%" }}>
                    <thead>
                        <th >Name </th>
                        <th >Professional Designation</th>
                        <th>Relationship</th>
                    </thead> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="name_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="professional_designation_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="relationship_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="name_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="professional_designation_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="relationship_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="name_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="professional_designation_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="relationship_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                </table>
            </div>
            <div className='mt-4 mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <span>E.&nbsp;&nbsp;&nbsp; Do you desire a <b><u>shared</u></b> or <b><u>separate</u></b> limit of liability to apply to your legal entity?</span>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="shared_liability" rules={[{ required: true }]} className="mb-0">
                        <Checkbox>Shared (limits are shared with you at no cost) </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="separate_liability" rules={[{ required: true }]}>
                        <Checkbox>Separate (subject to approval. Entity has its own set of limits and additional charge applies) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>3. Besides yourself, indicate the number of all chiropractors who work in your office or with whom you share space:</p>
                </div>
                <div className='ml-12 col-span-2 sm:col-span-1 lg:col-span-1'>
                    <Form.Item  name="list_memberships" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='mt-1 col-span-2 sm:col-span-5 lg:col-span-5'>
                    <span>Attach a separate application or proof of professional liability for each individual</span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>4.  Please complete the table below and advise the number of health care professionals working in practice:</p>
                </div>
            </div>
            <div className="flex flex-col justify-center">
                <table style={{ border: "solid 1px black", width: "95%" }}>
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "30%" }}>
                            Type
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "20%" }}>
                            # Employed
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "25%" }}>
                            # of Ind. Contractor
                        </td>
                        <td className ="mt-2 ml-6 text-center font-bold" style={{ border: "solid 1px black", width: "25%" }}>
                            # Sharing Space
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Chiropractor
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="chiropractor_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractor_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractor_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Chiropractic Assistant
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="chiropractic_assistant_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractic_assistant_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="chiropractic_assistant_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Massage Therapist
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="massage_therapist_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="massage_therapist_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="massage_therapist_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="pl-5" style={{ border: "solid 1px black", width: "30%" }}>
                            Other (specify)
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "20%" }}>
                            <Form.Item  className="mb-0" name="other_1" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="other_2" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                        <td className ="p-2" style={{ border: "solid 1px black", width: "25%" }}>
                            <Form.Item  className="mb-0" name="other_3" rules={[{ required: true }]}>
                                <Input/>
                            </Form.Item>
                        </td>
                    </tr> 
                </table>
                <div className="flex mt-2 font-bold">
                    IMPORTANT: Attach proof of professional liability insurance (other than your C.A.) for all employees,Independent Contractors and shared space arrangements.
                </div>
            </div>

            <div className='mt-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>5.  How many total hours per week are you practicing (includes time spent treating patients, noting charts and consulting, i.e. IME, Utilization Review, and Peer Review)?</p>
                </div>
                <div className='ml-8 col-span-2 sm:col-span-3 lg:col-span-3'>
                    <Form.Item label="Total Hours Per Week" name="total_hours_per_week" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 font-bold ml-16'>
                    <p>If 20 hours or less, complete a Part-Time Supplement </p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <p>6. Are you a team physician for any professional sports organization? </p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="risk_yes" valuePropName="checked" className="mb-0">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="risk_no" valuePropName="checked" className="mb-0">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-6 col-span-2 sm:col-span-6 lg:col-span-4'>
                    <p>If yes, please indicate the name of the team(s) </p>
                </div>
                <div className='ml-8 col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item name="team_name" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <p>7. Have you attended a risk-management seminar in the last 24 months?</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="risk_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="risk_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-8 col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Presenter" name="presenter" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Subject" name="subject" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <p>8. Do you use an “Informed Consent” in your office?</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="consent_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="consent_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <p>9. Do you have practice advertisements? (i.e. pamphlet, newspaper: If yes include copy)</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="advertisements_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="advertisements_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>10. If you are a provider for any Managed Healthcare Organizations, HMOs, PPOs, etc., please list them all. Check the adjacent box if you wish to add them as a Certificate Holder (C.H.)</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Organization Name" name="organization_name_1" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Mailing Address- Required for C.H." name="mailing_addr_ch_1" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-3'>
                    <Form.Item name="addr_for_ch_1" valuePropName="checked">
                        <Checkbox>Add as C.H. </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item label="Organization Name" name="organization_name_2" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <Form.Item label="Mailing Address- Required for C.H." name="mailing_addr_ch_2" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-3'>
                    <Form.Item name="addr_for_ch_2" valuePropName="checked">
                        <Checkbox>Add as C.H. </Checkbox>
                    </Form.Item>
                </div>
                <div className='mt-16 col-span-2 sm:col-span-6'>
                    <Title level={5}>IV. CLINICAL PRACTICE INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
                    <p>1. &nbsp;&nbsp;Please indicate the average number of patients seen monthly:</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="average_patients_seen_monthly" rules={[{ required: true }]}>
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>2. &nbsp;&nbsp;Check each of the following items provided by you or someone employed by you in your practice .
                    If you order tests, but the actual procedure is referred out, please identify by checking the “RO” box
                    (Referred Out).</p>
                </div>
            </div>
            <div className='mt-5 grid grid-cols-2 sm:grid-cols-12 gap-2'>
                <div className="ml-10 col-span-2 sm:col-span-6 lg:col-span-6">
                    <div className="grid grid-cols-2 sm:grid-cols-6 gap-2 bg-gray-200">
                        <div className='ml-2 mt-2 col-span-2 sm:col-span-6 lg:col-span-1'>
                            <CheckOutlined/>
                        </div>
                        <div className='mt-2 col-span-2 sm:col-span-6 lg:col-span-4'>
                            Procedure
                        </div>
                         <div className='mt-2 col-span-2 sm:col-span-6 lg:col-span-1'>
                            Refer
                        </div>
                    </div>
                </div>
                <div className="ml-10 col-span-2 sm:col-span-6 lg:col-span-6">
                    <div className="grid grid-cols-2 sm:grid-cols-6 gap-2 bg-gray-200">
                        <div className='ml-2 mt-2 col-span-2 sm:col-span-6 lg:col-span-1'>
                            <CheckOutlined/>
                        </div>
                        <div className='mt-2 col-span-2 sm:col-span-6 lg:col-span-4'>
                            Procedure
                        </div>
                         <div className='mt-2 col-span-2 sm:col-span-6 lg:col-span-1'>
                            Refer
                        </div>
                    </div>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="adjustments_check" className="mb-0" >
                        <Checkbox>Adjustments </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="adjustments_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="hair_analysis_check" className="mb-0">
                        <Checkbox>Hair Analysis </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="hair_analysis_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="cryotherapy_check" className="mb-0">
                        <Checkbox>Cryotherapy </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="cryotherapy_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-6'>
                    <Form.Item name="treatment_diagnosis_check" className="mb-0">
                        <Checkbox>Treatment or Diagnosis of Disease other than N.M.S. </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="litmus_paper_check" className="mb-0">
                        <Checkbox>Litmus Paper (B.E.S.T.) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="litmus_paper_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="foot_bath_check" className="mb-0">
                        <Checkbox>Foot Bath </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="foot_bath_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="ultra_sound_check" className="mb-0">
                        <Checkbox>Ultra Sound </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="ultra_sound_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="diagnostic_blood_check" className="mb-0">
                        <Checkbox>Interpretation of Diagnostic Blood Studies </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="diagnostic_blood_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="auriculotherapy_check" className="mb-0">
                        <Checkbox>Auriculotherapy </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="auriculotherapy_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="urinalysis_check" className="mb-0">
                        <Checkbox>Urinalysis </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="urinalysis_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="mri_ct_scan_check" className="mb-0">
                        <Checkbox>MRI/CT Scan </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="mri_ct_scan_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="homeopathy_check" className="mb-0">
                        <Checkbox>Homeopathy</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="homeopathy_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="diathermy_check" className="mb-0">
                        <Checkbox>Diathermy</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="diathermy_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="acupuncture_check" className="mb-0">
                        <Checkbox>Acupuncture</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="acupuncture_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="galvanic_stimulation_check" className="mb-0">
                        <Checkbox>Galvanic Stimulation</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="galvanic_stimulation_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="colon_irrigation_check" className="mb-0">
                        <Checkbox>Colon Irrigation</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="colon_irrigation_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="interferrential_check" className="mb-0">
                        <Checkbox>Interferrential</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="interferrential_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="drugs_prescribed_check" className="mb-0">
                        <Checkbox>Drugs prescribed or injected</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="drugs_prescribed_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="microcurrent_check" className="mb-0">
                        <Checkbox>Microcurrent</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="microcurrent_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="minor_surgery_check" className="mb-0">
                        <Checkbox>Minor Surgery</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="minor_surgery_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="traction_check" className="mb-0">
                        <Checkbox>Traction</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="traction_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="gynecology_exams_check" className="mb-0">
                        <Checkbox>Gynecology Exams</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="gynecology_exams_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="functional_neurology_check" className="mb-0">
                        <Checkbox>Functional Neurology</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="functional_neurology_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="mua_check" className="mb-0">
                        <Checkbox>MUA (Manipulation under Anesthesia)</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="mua_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="spinal_decompression_check" className="mb-0">
                        <Checkbox>Spinal Decompression</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="spinal_decompression_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="obstetrics_check" className="mb-0">
                        <Checkbox>Obstetrics</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="obstetrics_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="brain_core_therapy_check" className="mb-0">
                        <Checkbox>Brain Core Therapy</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="brain_core_therapy_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="vitamin_injections_check" className="mb-0">
                        <Checkbox>Vitamin Injections </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="vitamin_injections_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="morphogenic_field_check" className="mb-0">
                        <Checkbox>Morphogenic Field Technique </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="morphogenic_field_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="iridology_check" className="mb-0">
                        <Checkbox>Iridology</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="iridology_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="other_check" className="mb-0">
                        <Checkbox>Other (describe) </Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="other_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-5'>
                    <Form.Item name="invasive_emg_check" className="mb-0">
                        <Checkbox>Invasive EMG</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="invasive_emg_ro" className="mb-0">
                        <Checkbox>RO </Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-10 col-span-2 sm:col-span-6 lg:col-span-2'>
                    <Form.Item name="other_input" className="mb-0">
                        <Input/>
                    </Form.Item>
                </div>
            </div>

            <div className='mt-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6'>
                    <p>3. &nbsp;&nbsp;Percentages of Patients:</p>
                </div>
                
            </div>

            <div className="flex justify-center">
                <table style={{ border: "solid 1px black", width: "60%" }}>
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Newborn (Birth to 12 weeks)
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="newborn" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Pediatrics (12 weeks to 12 years)
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="pediatrics" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Pregnant
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="pregnant" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                    <tr className="h-12" style={{ border: "solid 1px black"}}>
                        <td className ="mt-2 ml-6" style={{ border: "solid 1px black", width: "70%" }}>
                            <div className="mt-2 ml-6 text-2sm">
                                Remainder
                            </div>
                        </td>
                        <td className="flex flex-row mt-2 items-center justify-center">
                            <div className="flex w-[30%]">
                                <Form.Item name="remainder" className="mb-0">
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div className="flex text-xl">
                                %
                            </div>
                        </td>
                    </tr> 
                </table>
            </div>

            <div className='mt-16 grid grid-cols-2 sm:grid-cols-6 gap-2'>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <p>4. Do you use any method or procedure other than non-force, or low-force for Newborn, Pediatrics or Pregnant patients?</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="other_method_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="other_method_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <p>5. Percentage of annual income generated from Nutritional Supplements</p>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="remainder" className="mb-0">
                        <Input/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 mt-1'>
                    <p>%</p>
                </div>
                <div className='col-span-2 sm:col-span-6'>
                    <Title level={5}>V. UNDERWRITING INFORMATION</Title>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 mt-1'>
                    <p>1. If the answer to any of the following questions is “YES”, please attach the information requested.</p>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>a.</b> Have you ever been convicted, found guilty, pleaded nolo contendere, or received probation 
                        without verdict as to any felony or misdemeanor, including any drug law violations or
                        any criminal charges pending and unresolved in any state or jurisdiction other than a
                        minor traffic violation?<br></br>
                        <b>If yes, provide details from investigating agency. </b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="narrow_convicted_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="narrow_convicted_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>b. </b> Have you ever been convicted of, pleaded guilty or no contest to a crime or a traffic violation involving drugs or alcohol? <br></br>
                        <b>If yes, provide details from investigating agency. </b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="broad_convicted_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="broad_convicted_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>c. </b> Have you ever suffered from or been treated for substance abuse, disability, mental illness, or serious physical illness/injury? <br></br>
                        <b>If yes, provide letter from treating physician with complete details</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="substance_abuse_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="substance_abuse_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>d. </b> Have you ever had a complaint filed against you (by a patient, other chiropractor, or insurer)
                        or an investigation conducted or pending with any any chiropractic board, association, foundation,
                        state or federal government authority including Licensing Board, Medicare, etc?<br></br>
                        <b>If yes, provide a copy of the board documents including resolution</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="complaint_filed_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="complaint_filed_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>e. </b> Have you ever had any professional license or permit investigated (even if dismissed), suspended, revoked, restricted or placed under probation?<br></br>
                        <b>If yes, provide a copy of the board documents including resolution</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="suspended_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="suspended_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>f. </b> Have you ever received a letter of concern/warning from the Board of Chiropractic Examiners
                        (of any state) or been under a board’s probation or stipulation? <br></br>
                        <b>If yes, provide a copy of the board documents including resolution</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="concern_warning_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="concern_warning_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>g. </b> Have you ever entered into any voluntary stipulation, order, consent agreement, or similar
                        action with a Board of Chiropractic Examiners (of any state)? <br></br>
                        <b>If yes, provide a copy of the board documents including resolution</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="stipulation_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="stipulation_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='ml-4 col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span><b>h. </b>Have you ever been denied any professional license or certification by a specialty board? <br></br>
                        <b>If yes, provide details from investigating agency. </b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="denied_license_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="denied_license_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span>2. Have you ever had professional liability insurance policy declined, canceled, issued on special terms
                        or been non-renewed, including for reasons of non-payment? <br></br>
                        <b>(This question is not applicable to Missouri residents.) </b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="professional_liability_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="professional_liability_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span>3. Have any claims or suits ever been made or brought against you? <br></br>
                        <b>If yes, complete one Supplemental Claim Information form for each incident.</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="claim_suit_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="claim_suit_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-4 mt-1'>
                    <span>4. Have you become aware of any fact or circumstance which resulted in or which could reasonably be
                            expected to result in a malpractice Claim, Incident or Suit?  <br></br>
                        <b>If yes, please complete one Supplemental Claim Information form for each incident.</b>
                    </span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1 ml-6'>
                    <Form.Item name="become_aware_yes" valuePropName="checked">
                        <Checkbox>Yes</Checkbox>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-1'>
                    <Form.Item name="become_aware_no" valuePropName="checked">
                        <Checkbox>No</Checkbox>
                    </Form.Item>
                </div>
                <div className='mt-4 col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    <span>Additional Comments/Notes :</span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    <Form.Item name="additional_comments" valuePropName="checked">
                        <TextArea rows={4}/>
                    </Form.Item>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    <span>COMPLETION OF THIS FORM NEITHER BINDS COVERAGE NOR GUARANTEES A POLICY WILL BE ISSUED</span>
                </div>
                <div className='col-span-2 sm:col-span-6 lg:col-span-6 font-bold'>
                    <span>I HEREBY CERTIFY THAT I HAVE READ THE ABOVE APPLICATION AND THAT ALL STATEMENTS IN
                        THIS APPLICATION ARE TRUE, MATERIAL AND COMPLETE. I UNDERSTAND THAT: (1) IF THE
                        POLICY IS ISSUED, THIS IS DONE IN RELIANCE UPON THESE REPRESENTATIONS; AND, (2) ANY
                        POLICY OBTAINED BY FRAUD, MATERIAL MISREPRESENTATION OR OMISSION IS NULL & VOID.<br></br><br></br>
                        I AGREE THAT A COPY OF MY SIGNATURE MAY BE RELIED UPON AS IF IT WERE THE ORIGINAL. 
                    </span>
                </div>
            </div>    
            

            <div className='grid grid-cols-1 gap-4 mt-4'>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button type="primary" htmlType="submit">Submit</Button>
                </div>
            </div>
        </Form>
      </div>
    </div>
  );
};

export default NewFormPage;